import React from "react"
import "./style.scss"
import Image from "../../Image";

const Breadcrumb = props => {
    const {product, title} = props
    
    return (
        <div id="breadcrumb" className="relative overflow-hidden h-320 bg-white">
            <div className="bg-1 bg-blue hidden sm:block absolute -ml-96 -mt-40 z-30"/>
            <div className="bg-2 hidden sm:block absolute transform rotate-45 -ml-96 z-20"/>
            <div className="bg-3 hidden sm:block absolute bg-purple transform -ml-40 top-0 z-20"/>
            <div className="bg-4 bg-blue w-full h-14 bottom-0 block absolute transform text-center">
                {product && product.isNew && (
                    <h3 className="absolute z-50 text-center w-full transform -translate-y-1/2 -translate-x-1/2 top-1/2 left-1/2 text-2xl text-darkpurple font-bold">Lançamento</h3>
                )}
            </div>
            <div className="relative container mx-auto px-4 h-full">
                {product && product.logo && (
                    <Image src={product.logo} className="hidden md:block absolute z-40" />
                )}
                <h1 className="absolute z-40 text-center w-9/12 transform -translate-y-full -translate-x-1/2 top-1/2 left-1/2 text-4xl text-darkblue font-bold">{product?product.name:title}</h1>
            </div>
        </div>
    )
}

export default Breadcrumb
